export default __webpack_public_path__ + "static/media/04.d8e0ec86.webp";